export const REMEMBERED_TIME_CLOCK_TYPE = 'remember_time_clock_choice';
export const TIME_CLOCK_TYPE_SHARED = 'shared';
export const TIME_CLOCK_TYPE_PERSONAL = 'personal';
export const TIME_CLOCK_PATH = '/web_timeclock';
